// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2a0cbb07","749":"2b3547ea","903":"38d2b4dd"}[chunkId] + ".chunk.js";
};